<template>
  <div v-if="quantity">
    <input
      v-model="selected"
      class="form-check-input"
      type="checkbox"
      @change="handleSelect"
    />
    <label class="form-check-label ml-2">{{ part.name }}</label>
    <div v-if="selected" class="px-5 mb-3 form-group row">
      <input
        class="hidden"
        :name="'parts[' + parentIndex + '][' + selfIndex + '][type]'"
        :value="part.type"
      />
      <input
        class="hidden"
        :name="'parts[' + parentIndex + '][' + selfIndex + '][id]'"
        :value="part.id"
      />
      <label class="col">Quantity:</label>
      <select
        v-model="selectedQuantity"
        class="form-control col"
        :name="'parts[' + parentIndex + '][' + selfIndex + '][quantity]'"
      >
        <option value="0">0</option>
        <option
          v-for="q in quantity"
          :key="part.id + '-quantity-' + q"
          :value="q"
        >
          {{ q }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    part: {
      type: Object,
      required: true,
    },
    adjustmentType: {
      type: String,
      required: true,
    },
    selfIndex: {
      type: Number,
      required: true,
    },
    parentIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selected: false,
      selectedQuantity: 0,
    };
  },
  computed: {
    quantity() {
      return this.part.quantity[this.adjustmentType];
    },
    total() {
      return this.selectedQuantity * this.part.price;
    },
  },
  watch: {
    total() {
      return this.$emit("partTotalUpdated", this.selfIndex, this.total);
    },
  },
  methods: {
    handleSelect() {
      if (!this.selected) this.selectedQuantity = 0;
      return this.$emit("updateSelected", this.selfIndex, this.selected);
    },
  },
};
</script>
